

export const TokenLogout=(error)=>{
    if(error.response&&error.response.status===401){
        setTimeout(()=>{
            localStorage.clear();
            sessionStorage.clear();
            window.location.href='/'
        },2500)
        
    }
}